<template>
  <div>
    <b-modal
      :title="getTitleModal"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('close')"
      no-close-on-backdrop
      no-close-on-esc
      v-model="show"
      size="xmd"
    >
      <ValidationObserver ref="ref-aprobar-gratificacion" v-slot="{ invalid }">
        <b-form>
          <!-- <h5 class="my-1 fw-bold">Datos</h5> -->
          <b-row>
            <b-col md="2">
              <b-form-group label="Fecha Ingreso">
                <b-form-input
                  type="date"
                  v-model="form.fecha_ingreso"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Periodo Inicio">
                <b-form-input
                  type="date"
                  v-model="form.fecha_inicio"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Periodo Fin">
                <b-form-input type="date" v-model="form.fecha_fin" disabled />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Meses Computable">
                <b-form-input
                  type="number"
                  v-model="form.meses_computables"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Faltas Injustificadas">
                <b-form-input
                  type="number"
                  v-model="form.faltas_injustificadas"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h5 class="my-1 fw-bold border-top pt-1">Conceptos Computables</h5>

          <b-row>
            <b-col cols="6" class="d-flex flex-column">
              <h5 class="fw-bold">Fijos</h5>

              <b-row class="align-items-center">
                <b-col md="6">
                  <span>Remuneración Básica</span>
                </b-col>
                <b-col md="6">
                  <money
                    v-model="form.sueldo_computable"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
                <b-col md="6" class="mt-1">
                  <span>Asignación Familiar</span>
                </b-col>
                <b-col md="6" class="mt-1">
                  <money
                    v-model="form.asignacion_familiar"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
                <b-col md="6" class="mt-1">
                  <span>Alimentación Principal</span>
                </b-col>
                <b-col md="6" class="mt-1">
                  <money
                    v-model="form.asignacion_alimentaria"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
              </b-row>

              <b-row class="mt-auto align-items-center">
                <b-col md="6" class="mt-2">
                  <span class="fw-bold">Total Conceptos Fijos</span>
                </b-col>
                <b-col md="6" class="mt-2">
                  <money
                    v-model="form.total_conceptos_fijos"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="d-flex flex-column">
              <h5 class="fw-bold">Variables</h5>

              <b-row class="align-items-center">
                <b-col md="6">
                  <span>Horas Extras</span>
                </b-col>
                <b-col md="6">
                  <money
                    v-model="form.horas_extras"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                  />
                </b-col>
                <b-col md="6" class="mt-1">
                  <span>Comisiones</span>
                </b-col>
                <b-col md="6" class="mt-1">
                  <money
                    v-model="form.comisiones"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
                <b-col md="6" class="mt-1">
                  <span>Bonos</span>
                </b-col>
                <b-col md="6" class="mt-1">
                  <money
                    v-model="form.bonos"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
                <b-col md="6" class="mt-1">
                  <span>Otros</span>
                </b-col>
                <b-col md="6" class="mt-1">
                  <money
                    v-model="form.otros"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
              </b-row>

              <b-row class="mt-auto align-items-center">
                <b-col md="6" class="mt-2">
                  <span class="fw-bold">Total Conceptos Variables</span>
                </b-col>
                <b-col md="6" class="mt-2">
                  <money
                    v-model="form.total_conceptos_variables"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" class="mt-3">
              <b-row class="mt-auto align-items-center">
                <b-col md="3">
                  <span class="fw-bold">Total Conceptos Computables</span>
                </b-col>
                <b-col md="3">
                  <money
                    v-model="form.total_conceptos_computables"
                    v-bind="moneyConfig"
                    class="form-control form-control-sm"
                    disabled
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- {{ gratificacionData }} -->

          <h5 class="my-1 fw-bold border-top pt-1">
            Cálculo de la gratificación
          </h5>
          <b-row>
            <b-col md="3">
              <b-form-group label="Remuneración Computable">
                <money
                  v-model="form.total_conceptos_computables"
                  v-bind="moneyConfig"
                  class="form-control form-control-sm"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Periodo Computable">
                <b-form-input
                  type="number"
                  v-model="periodoComputable"
                  disabled
                  size="sm"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Periodo Laborable">
                <b-form-input
                  type="number"
                  v-model="form.meses_computables"
                  disabled
                  size="sm"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Gratificación Completa">
                <money
                  v-model="form.gratificacion_completa"
                  v-bind="moneyConfig"
                  class="form-control form-control-sm"
                  disabled
                  size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h5 class="my-1 fw-bold border-top pt-1">
            Descuento por inasistencias no justificadas
          </h5>
          <b-row>
            <b-col md="3">
              <b-form-group label="Faltas Injustificadas">
                <b-form-input
                  type="number"
                  v-model="form.faltas_injustificadas"
                  disabled
                  size="sm"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Factor x dia">
                <money
                  v-model="form.factor_por_dia"
                  v-bind="moneyConfig"
                  class="form-control form-control-sm"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Monto a descontar">
                <money
                  v-model="form.monto_a_descontar"
                  v-bind="moneyConfig"
                  class="form-control form-control-sm"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Gratificacion neta">
                <money
                  v-model="form.gratificacion_neta"
                  v-bind="moneyConfig"
                  class="form-control form-control-sm"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h5 class="my-1 fw-bold border-top pt-1">
            Cálculo de la bonificación extraordinaria
          </h5>
          <b-row>
            <b-col md="3">
              <!-- <b-form-group label="Faltas Injustificadas">
                <b-form-input
                  type="number"
                  v-model="form.faltas_injustificadas"
                  disabled
                  size="sm"
                />
              </b-form-group> -->
              <span>Gratificación</span>
            </b-col>

            <b-col md="3">
              <!-- <b-form-group label="Gratificación"> -->
              <money
                v-model="form.gratificacion_neta"
                v-bind="moneyConfig"
                class="form-control form-control-sm"
                disabled
              />
              <!-- </b-form-group> -->
            </b-col>

            <b-col md="3">
              <!-- <b-form-group label="9%"> -->
              <money
                v-model="nuevePorciento"
                v-bind="porcentajeConfig"
                class="form-control form-control-sm"
                disabled
              />
              <!-- </b-form-group> -->
            </b-col>

            <b-col md="3">
              <!-- <b-form-group label="Bonificación Extraordinaria 9%"> -->
              <money
                v-model="form.gratificacion_nueve_por_ciento"
                v-bind="moneyConfig"
                class="form-control form-control-sm"
                disabled
              />
              <!-- </b-form-group> -->
            </b-col>
          </b-row>

          <b-row class="mt-1 align-items-center">
            <b-col md="3">
              <span class="fw-bold text-primary">Monto a percibir</span>
            </b-col>
            <b-col md="3">
              <money
                v-model="form.monto_a_percibir"
                v-bind="moneyConfig"
                class="form-control form-control-sm"
                disabled
              />
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>

      <div class="d-flex justify-content-end gap-x-3 mt-1">
        <b-button variant="outline-primary" @click="recalcular">
          RECALCULAR
        </b-button>
        <b-button variant="primary" @click="approve">APROBAR</b-button>
      </div>
    </b-modal>

    <GratificacionConfirmacionModal
      v-if="showConfirmacionAprobacionGrati"
      :idGratificaciones="idGratificacionesToApprove"
      @close="showConfirmacionAprobacionGrati = false"
      @confirmed="handleConfirmacionAprobacionGrati"
    />
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import GratificacionesService from "@/views/rrhh/views/payroll/components/gratificaciones/service/gratificaciones.service.js";
import GratificacionConfirmacionModal from "@/views/rrhh/views/payroll/components/gratificaciones/components/GratificacionConfirmacionModal.vue";
export default {
  components: {
    flatPickr,
    GratificacionConfirmacionModal,
  },
  props: {
    gratificacionData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        periodo: null,
        anio: null,
      },
      nuevePorciento: 9,
      moneyConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "S/. ",
        precision: 2,
        masked: false,
      },
      porcentajeConfig: {
        decimal: ".",
        thousands: ",",
        suffix: " % ",
        precision: 2,
        masked: false,
      },
      periodoComputable: 6,
      showConfirmacionAprobacionGrati: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      return `Aprobar Gratificación - ${this.gratificacionData.empleado} (${this.form.periodo} / ${this.form.anio})`;
    },
    idGratificacionesToApprove() {
      let gratificaciones = [];

      gratificaciones.push({
        user_id: this.currentUser.id,
        gratificacion_id: this.gratificacionData.id,
      });

      return gratificaciones;
    },
  },
  mounted() {
    this.getGratificacion();
  },
  methods: {
    handleConfirmacionAprobacionGrati() {
      this.$emit("approveGrati", {
        user_id: this.currentUser.id,
        gratificacion_id: this.gratificacionData.id,
      });
    },
    async approve() {
      this.showConfirmacionAprobacionGrati = true;
    },
    // async aprobarGratificacion() {
    //   try {
    //     const result = await this.$refs["ref-aprobar-gratificacion"].validate();

    //     if (!result) {
    //       this.showToastError("Por favor complete los campos requeridos.");
    //       return;
    //     }

    //     this.addPreloader();

    //     const params = {
    //       periodo: this.form.periodo,
    //       anio: this.form.anio,
    //       empleados: [this.gratificacionData.employee_id],
    //     };

    //     const { data } = await GratificacionesService.aprobar(params);

    //     this.$toast({
    //       component: ToastificationContent,
    //       position: "top-right",
    //       props: {
    //         title: "Éxito",
    //         icon: "CheckCircleIcon",
    //         variant: "success",
    //         text: data.message || "Gratificación aprobada correctamente.",
    //       },
    //     });
    //     this.$emit("refresh");
    //   } catch (error) {
    //     this.$toast({
    //       component: ToastificationContent,
    //       position: "top-right",
    //       props: {
    //         title: "Error",
    //         icon: "XCircleIcon",
    //         variant: "danger",
    //         text: error?.response?.data || error.message || error,
    //       },
    //     });
    //   } finally {
    //     this.removePreloader();
    //   }
    // },
    async recalcular() {
      try {
        this.addPreloader();
        const params = {
          id: this.gratificacionData.id,
          horas_extras: this.form.horas_extras,
          periodo: this.form.periodo,
          anio: this.form.anio,
        };
        await GratificacionesService.generar(params);

        await this.getGratificacion();
      } catch (error) {
        this.showToastError(
          error.response?.data || error.message || "Error al recalcular"
        );
      } finally {
        this.removePreloader();
      }
    },
    async getGratificacion() {
      try {
        this.addPreloader();
        const params = {
          id: this.gratificacionData.id,
        };
        const { data } = await GratificacionesService.show(params);

        this.form = data[0];

        // console.log("data", data[0]);
      } catch (error) {
        this.showToastError(
          error.response?.data || error.message || "Error al cargar datos"
        );
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
<style scoped>
.fw-bold {
  font-weight: bold;
}
</style>
